"use client"
import React from "react"
import { IntlProvider } from "next-intl"
import { GetStaticProps } from "next"
import LandingContent from "src/components/LandingContent"

export const getStaticProps: GetStaticProps = async (context) => {
  // Next sets context.locale when i18n is enabled
  const locale = (context.locale as string) || "de"

  let messages
  try {
    messages = (await import(`../src/intl/${locale}.json`)).default
  } catch (err) {
    // fallback to default
    messages = (await import(`../src/intl/de.json`)).default
  }

  return {
    props: {
      messages,
      locale,
    },
  }
}

export default function IndexPage({ messages, locale }: { messages: Record<string, any>; locale: string }) {
  return (
    <IntlProvider locale={locale} messages={messages}>
      <LandingContent />
    </IntlProvider>
  )
}
